module.exports = __webpack_public_path__ + "img/other_GalaxyS20Ultra5G.7c89777c.png";